var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 3.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 8.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 13.75Z",
    fill: "currentColor"
  })));
};
export default SvgDotsVertical;